export default {
  primary: "#1C79FF",
  white: "#FFF",
  darkBackground: "#2C2E2E",
  textFieldBackground: "#181C1E",
  textFieldLightBackground: "#e3f2fd",
  primaryWithOPacity: "rgba(24, 94, 254, 0.28)",
};
